// extracted by mini-css-extract-plugin
export default {"text":"FindingOpponent2_text__VFEPA","text_vs":"FindingOpponent2_text_vs__F-2gh"};